import { useMutation } from "@apollo/client";

import { STAND_ATTCHMENT_CREATE } from "graphql/mutation/stand-gql";
import { successNotification, errorNotification } from "components/request-result";


const useMutationStandAttachmentCreate = ({
    showSuccessNotification = true,
    showErrorNotification = true,
    onCompleted = () => {},
    onError = () => {},
} = {}) => {
    const [ _setStandAttachmentCreate, { loading } ] = useMutation(STAND_ATTCHMENT_CREATE, {
        update(cache, { data }) {
            const payload = data?.attachmentCreate;
            if (showSuccessNotification && payload?.label) {
                successNotification({
                    title: payload.label,
                    description: payload.message,
                });
            }
            onCompleted(payload);
        },
        onError(error) {
            if (showErrorNotification) {
                errorNotification(error);
            }
            onError(error);
        },
    });

    return {
        _setStandAttachmentCreate,
        loadingMutationStandAttachmentCreate: loading,
    };
};

export default useMutationStandAttachmentCreate;
